module.exports = __webpack_public_path__ + "img/add_desktop_2.578854ff.png";